// common — am. Part of the am i18n bundle; merged by ./index.js

export default {
// Navbar
  home: 'ዋና ገጽ',
  about: 'ስለ እኛ',
  contact: 'ያግኙን',
  signIn: 'ግባ',
  signOut: 'ውጣ',
  myDashboard: 'የእኔ ዳሽቦርድ',
  team: 'ቡድን',
  linksWebsite: 'ድህረ ገጽ',
  allCities: '📍 ሁሉም ከተሞች',
  clearFilter: '✕ አጽዳ',
  noClientsInCity: (city) => `በ${city} ምንም ደንበኛ አልተገኘም።`,
  allClientsLabel: 'ሁሉም ደንበኞች',
  verifiedBusinesses: 'የምናስተዋውቃቸው ተረጋግጠው ፈቃድ ያላቸው ንግዶች',
  verified: '✓ ተረጋግጧል',
  noClients: 'እስካሁን ደንበኞች የሉም።',
  aboutSub: 'እኛ ነን',
  vision: 'ራዕይ',
  mission: 'ተልዕኮ',
  visionText: 'MSMEዎችን ለማብቃት ኢትዮጵያ ውስጥ ቀዳሚ የዲጂታል ማርኬቲንግ እና ማስታወቂያ ኩባንያ መሆን።',
  missionText: 'የኢትዮጵያ MSMEዎች ዘላቂ እድገት እንዲያሳኩ የሚረዱ ፈጠራዊ፣ ተመጣጣኝ እና ሊለካ የሚችሉ የማርኬቲንግ እና ማስታወቂያ መፍትሄዎችን ማቅረብ።',
  so1: 'በሀገር አቀፍ ደረጃ ሙያዊ የማርኬቲንግ አገልግሎቶችን ማቅረብ',
  so2: 'MSMEዎችን በዲጂታል ታይነት እና ብራንዲንግ ማሳደግ',
  so3: 'ቴክኖሎጂን (ድህረ ገጽ፣ ሞባይል አፕ እና ሶሻል ሚዲያ) ለአገልግሎት አቅርቦት መጠቀም',
  so4: 'ከMSMEዎች እና ተቋማት ጋር የረጅም ጊዜ አጋርነት መገንባት',
  so5: 'ለተሰጠ ወጣቶች የስራ ዕድሎችን መፍጠር',
// Contact,
  contactTitle: 'ያግኙን',
  contactSub: 'ንግድዎን ለማሳደግ ዝግጁ ነዎት?',
  message: 'መልዕክት',
  successTitle: 'መልዕክት ተልኳል!',
  successMsg: 'እናመሰግናለን! በቅርቡ እናገኝዎታለን።',
  sendAnother: 'ሌላ ይላኩ',
  selectType: 'አይነት ይምረጡ...',
  passwordPlaceholder: 'የይለፍ ቃል *',
  confirmPassword: 'የይለፍ ቃል ያረጋግጡ *',
  minPassword: 'ቢያንስ 6 ቁምፊዎች',
  alreadyHave: 'አስቀድሞ መለያ አለዎት?',
  businessDocsTitle: 'የንግድ ሰነዶች',
  registrationFailed: 'ምዝገባ አልተሳካም።',
// Login,
  loginTitle: 'ወደ መለያዎ ይግቡ',
  loginBtn: 'ግባ →',
  loggingIn: 'በመግባት ላይ...',
  noAccount: 'መለያ የለዎትም?',
  registerBusiness: 'ንግድዎን ይመዝግቡ',
  loginFailed: 'መግባት አልተሳካም።',
// Navbar extras,
  blogsNews: 'ብሎጎች/ዜና',
  faq: 'ተደጋጋሚ ጥያቄዎች',
  faqSubtitle: 'ስለ ኦል ቲንግስ፣ ባዛር እና አገልግሎቶቻችን ማንኛውም ነገር ማወቅ የሚፈልጉት።',
  faq1q: 'ኦል ቲንግስ ማነው?',
  faq1a: 'ኦል ቲንግስ በአዲስ አበባ፣ ኢትዮጵያ የመሰረተ ዲጂታል ማርኬቲንግ ኤጀንሲ እና የኢ-ኮሜርስ መድረክ ነው። ለተፈቃዱ የኢትዮጵያ ንግዶች በማርኬቲንግ አገልግሎቶች እና በባዛር ገበያ በመስራት በመስመር ላይ እንዲያድጉ እንረዳለን።',
  faq2q: 'እንዴት እንደ ሻጭ ልመዝገብ?',
  faq2a: 'ወደ ያግኙን ገጽ ቀጥል እና የንግድ ዝርዝሮችዎን በመጠቀም ቅጹን ይሙሉ፣ የTIN ቁጥር፣ የንግድ ፈቃድ እና የኤልሚስ ምዝገባ ጨምር። ቡድናችን ማመልከቻዎን ይገመግማል።',
  faq3q: 'ከባዛር እንዴት እን ይገዛ?',
  faq3a: 'በባዛር ውስጥ ምርቶችን ያሱ፣ እቃዎችን ወደ ጋሪዎ ያክሉ እና ወደ ክፍያ ቀጥል። በፊት እንደ ገዢ መመዝገብ ያለብዎት። ክፍያው በቀጥታ ከርስዎ ከሻጩ ጋር ይከናወናል።',
  faq4q: 'ምን ዓይነት የክፍያ ዘዴዎች ይቀበላሉ?',
  faq4a: 'የክፍያ ዘዴዎች በሻጭ ይለያያሉ። ብዙዎቹ የባንክ ዝውውር፣ ሞባይል ገንዘብ ወይም በአዲስ አበባ ውስጥ በመጋብዛት ይቀበላሉ። የሻጩን የክፍያ አማራጭ ለማየት የምርቱን ገጽ ይፈትሹ።',
  faq5q: 'ዴሊቨሪ እንዴት ይሠራል?',
  faq5a: 'ዴሊቨሪ አቀናብሮ ከመግዛት በኋላ በቀጥታ ከሻጩ ጋር ይከናወናል። ብዙ ሻጮች በአዲስ አበባ ውስጥ ዴሊቨሪ ይሰጣሉ። በቻት ባህሪ በመጠቀም ከሻጩ ጋር ስለ ዴሊቨሪ አማራጭ ማውራት ይችላሉ።',
  faq6q: 'የመመለሻ ፖሊሲ አለ?',
  faq6a: 'መመለሻዎች በርስዎ ከሻጩ ጋር ይከናወናል። መግዛት ከመፈረጋት በፊት የሻጩን የመመለሻ ፖሊሲ ለማረጋገጫ በመድረኩ ላይ መልዕክት መላክ እንመክራለን።',
  faq7q: 'እንዴት እንደ ዲጂታል ማርኬቲንግ ደንበኛ ልሆን?',
  faq7a: 'በያግኙን ገጽ ወይም በallthingsethiopia2026@gmail.com ያግኙን። የንግድ ፍላጎቶችዎን እንወያያለን እና ልዩ የማርኬቲንግ ዕቅድ እንፍጥራለን።',
  faq8q: 'ኦል ቲንግስ ምን አገልግሎቶች ያቀርባል?',
  faq8a: 'ለኢትዮጵያ ንግዶች ዲጂታል ማርኬቲንግ፣ የሶሻል ሚዲያ አስተዳደር፣ ድህረ ገጽ ግንባታ፣ ብራንዲንግ፣ ይዘት መፍጠር እና የኢ-ኮሜርስ መፍትሄዎች እንቀርባለን።',
// About extras,
  aboutTag: 'ስለ እኛ',
  aboutHeroTitle1: 'ኢትዮጵያን',
  aboutHeroTitle2: 'የዲጂታል ወደፊት ማበረታታት',
  aboutCatalyst: 'እኛ በዘመናዊ የንግድ ገበያ ውስጥ የኢትዮጵያ MSMEዎች እድገት መካከልኛ ነን።',
  whoWeAre: 'ማን ነን',
  whoWeAreText: 'እኛ የኢትዮጵያ MSMEዎች ከባህላዊ የንግድ ዘዴዎች ወደ ዘመናዊ፣ ቴክኖሎጂ-ተመሳሳይ እድገት እንዲመላለሱ የረዳ ዲጂታል ማርኬቲንግ እና የኢ-ኮሜርስ ድጋፍ መድረክ ነን። ተልዕኮአችን ከአካባቢ ጥራት እና ከዓለም አቀፍ ታይነት መካከል ያለውን ክፍተት መቀረዝ ነው።',
  ourCoreValues: 'መሰረታዊ',
  ourCoreValuesHighlight: 'እሴቶቻችን',
  strategic: 'ስትራቴጂካዊ',
  strategicHighlight: 'ዓላማዎች',
// Register extras,
  joinAllThings: 'ኦል ቲንግስ',
  joinAllThingsHighlight: 'ተቀላቀል',
  chooseAccountType: 'ለመጀመር የአካውንት አይነትዎን ይምረጡ',
  registerYourBusiness: 'ለሙያዊ ማስታወቂያ አገልግሎት ፈቃድ ያለውን ንግድዎን ይመዝግቡ።',
  haveAccount: 'አስቀድሞ መለያ አለዎት?',
  registrationSubmitted: 'ምዝገባ ተልኳል!',
  thankYouName: (name) => `${name} አመሰግናለን!`,
  thankYouRegistering: 'መለያዎ በግምገማ ላይ ነው። ቡድናችን ንግድዎን በ48 ሰዓት ውስጥ ይረጋግጣል።',
  goToLogin: 'ወደ መግቢያ ተመለስ',
  selectCity: 'ከተማ ይምረጡ...',
// Login extras,
  forgot: 'ረሱ?',
// Contact info card labels,
  labelEmail: 'ኢሜይል',
  labelLocation: 'አድራሻ',
  labelPhone: 'ስልክ',
  labelHours: 'ሰዓት',
  labelTelegram: 'ቴሌግራም',
  labelWhatsApp: 'ዋትሳፕ',
  messages: '💬 መልዕክቶች',
  noConversations: 'እስካሁን ውይይቶች የሉም።',
  selectConversation: 'ውይይት ይምረጡ ለመጀመር',
  typeMessage: 'መልዕክት ይጻፉ...',
  new: 'አዲስ',
// Dashboard,
  changePassword: 'የይለፍ ቃል ቀይር',
  copyright: '© 2026 ኦል ቲንግስ ሶሉሽን PLC',
// Client detail,
  backToClients: '← ወደ ደንበኞች ተመለስ',
  established: 'የተቋቋመበት',
  location: 'አካባቢ',
  verifiedLicensed: 'ተረጋግጦ ፈቃድ ያለው ንግድ',
  licenseLabel: 'ፈቃድ',
  ourMarketingWork: 'የእኛ የማርኬቲንግ ስራ',
  contactSocial: 'ያግኙን እና ሶሻል ሚዲያ',
// Core values,
  cv1Title: 'ፈጠራ እና ፈጠራ',
  cv1Desc: 'አዳዲስ ሀሳቦችን እና ፈጠራ መፍትሄዎችን እንቀበላለን',
  cv2Title: 'ደንበኛ ማዕከላዊ አገልግሎት',
  cv2Desc: 'የደንበኞቻችን ስኬት ለሁሉም ነገር ማዕከል ነው',
  cv3Title: 'ታማኝነት እና ግልጽነት',
  cv3Desc: 'በታማኝነት እና ግልጽነት እንሰራለን',
  cv4Title: 'ቴክኖሎጂ ተቀባይነት',
  cv4Desc: 'የቅርብ ጊዜ ዲጂታል መሳሪያዎችን እንጠቀማለን',
  cv5Title: 'ውጤት ተኮር አፈጻጸም',
  cv5Desc: 'ሊለካ በሚችሉ ውጤቶች ላይ እናተኩራለን',
// Team,
  teamOurPeople: 'ሰዎቻችን',
  teamTitle: 'ቡድናችንን',
  teamTitleHighlight: 'ይወቁ',
  teamSubtitle: 'ኦል ቲንግስ ሶሉሽን ጀርባ ያሉ ተሰጥኦ ያላቸው ሰዎች',
  legalTitle: 'ሕግ ወይም ፖሊሲዎች',
  legalTerms: 'ውሎች እና ሁኔታዎች',
  legalPrivacy: 'የግላዊነት ፖሊሲ',
  legalBilling: 'የክፍያ ፖሊሲ',
  legalCookie: 'የኩኪ ፖሊሲ',
  legalCopyright: 'የቅጅ መብት ፖሊሲ',
  showPassword: 'የይለፍ ቃል አሳይ',
  hidePassword: 'የይለፍ ቃል ደብቅ',
  cartTitle: 'ጋሪዎ',
  checkoutTitle: 'ክፍያ',
  deliveryTitle: 'ዴሊቨሪ ይጠይቁ',
  addToCart: 'ወደ ጋሪ ጨምር',
  proceedToCheckout: 'ወደ ክፍያ ቀጥል',
  placeOrder: 'ትዕዛዝ ስጥ',
  addProduct: 'ምርት ጨምር',
  editProduct: 'ምርት አርትዕ',
  deleteProduct: 'ምርት ሰርዝ',
  outOfStock: 'ክምችት አልቋል',
  selectBank: 'የክፍያ ዘዴ ምረጥ',
  uploadScreenshot: 'ስክሪንሾት ስቀል',
  enterReference: 'የማጣቀሻ ቁጥር አስገባ',
  cartTotal: 'ጠቅላላ',
  linkedOrder: 'ትዕዛዝ ምረጥ',
  deliveryAddress: 'የዴሊቨሪ አድራሻ',
  contactPhone: 'የእውቂያ ስልክ',
  preferredTime: 'የሚፈለግ የዴሊቨሪ ጊዜ',
  outOfStockError: 'አንዳንድ ምርቶች ክምችት አልቋቸዋል።',
  deliveryDuplicateError: 'ለዚህ ትዕዛዝ የዴሊቨሪ ጥያቄ አስቀድሞ አለ።',
  backToBazaar: '← ወደ ባዛር ተመለስ',
  allCategories: 'ሁሉም ምድቦች',
  noOrders: 'እስካሁን ትዕዛዞች የሉም።',
  filters: 'ማጣሪያዎች',
  priceRangeEtb: 'የዋጋ ክልል (ETB)',
  anyPrice: 'ማንኛውንደም ዋጋ',
  added: 'ተጨምሯል',
  days: 'ቀናት',
  hours: 'ሰዓታት',
  minutes: 'ደቂቃዎች',
  seconds: 'ሰከንድ',
  reopensAt: (x) => `በ${x} ይከፍታል`,
// Buyer account,
  registerAsSeller: 'እንደ ሻጭ ተመዝገብ',
  registerAsBuyer: 'እንደ ገዢ ተመዝገብ',
  buyerRegisterTitle: 'የገዢ መለያ ይፍጠሩ',
  buyerDashboardTitle: 'የግዢ ታሪኬ',
  groupedByCategory: 'በምድብ',
  groupedBySeller: 'በሻጭ',
  noPurchases: 'እስካሁን ምንም ግዢ የለም።',
  instantlyActive: 'መለያዎ ንቁ ነው!',
  ourRoots: 'መሬታችን',
  bridgingTitle: 'ባህላዊነትን እና',
  bridgingHighlight: 'ፈጠራን መካከል',
  rootsText: 'የኢትዮጵያ MSMEዎችን በዓለም አቀፍ ዲጂታል መልክዓ ምድር ውስጥ እንዲያድጉ እንረዳለን፣ ሀብታም ባህላችን እንዲጠብቁ በመሆን። ከአካባቢ ገበያዎች እስከ ዲጂታል ሱቃኖች፣ በእድገት ባጋሪ ነን።',
  ourStory: 'ታሪካችን',
  servicesBoost: 'ንግድዎን ለማሳደግ የምንሰጥ አገልግሎቶች',
  appStore: 'አፕ ሱቅ',
  googlePlay: 'ጉግል ፕሌይ',
// Service cards,
  svcSocialMedia: 'የሶሻል ሚዲያ አስተዳደር',
  svcSocialMediaDesc: 'የሶሻል ሚዲያ መለያዎችዎን በደጋሚ ማስቀመጥ፣ ተከታይ ተሳትፎ እና ይዘት ስትራቴጂ ሙሉ አስተዳደር።',
  svcContentCreation: 'ይዘት መፍጠር',
  svcContentDesc: 'የብራንድ ታሪክዎን የሚነግሩ እና ታሪኮችን የሚይዙ ሙያዊ ፎቶዎች፣ ቪዲዮዎች እና ግራፊክስ።',
  svcGrowthStrategy: 'የዕድገት ስትራቴጂ',
  svcGrowthDesc: 'ንግድ እድገትዎን ማፍጠን እና የገበያ ትስስር ለማስፋፋት የተነሳ የውሂብ ስትራቴጂዎች።',
  svcPaidAds: 'የሚከፈልበት ማስታወቂያ',
  svcAdsDesc: 'በሁሉም መድረኮች ላይ ROI ማስፋፋት እና ትክክለኛ ተወዳጅን ማድረስ ዒላማ ያደረጉ ማስታወቂያ ዘመቻዎች።',
  svcBranding: 'ብራንዲንግ እና ሎጎ ዲዛይን',
  svcBrandingDesc: 'የሚታወቀ የብራንድ ማንቂያ፣ ሎጎ መፍጠር እና ከተፎካካሪዎች የሚለይ የምስል ታሪክ።',
  svcOutdoor: 'የውጪ ማስታወቂያ',
  svcOutdoorDesc: 'የዲጂታል ማርኬቲንግ ጥረትዎን ለማጠናከር ባይልቦርዶች፣ ባነሮች እና የውጪ ታይነት መፍትሄዎች።',
  svcEcommerce: 'ኢ-ኮሜርስ ማስቀመጥ',
  svcEcomDesc: 'ሙሉ የመዝገቢ ሱቅ ማስቀመጥ፣ የምርት ዝርዝር እና በኦል ቲንግስ ባዛር ገበያ ማተም።',
  svcConsultation: 'የንግድ ምክር',
  svcConsultDesc: 'ንግድዎን በዲጂታል መልክዓ ምድር በተሳካ ሁኔታ እንዲያቀርብ የሚረዳ ባለሙያ መሪ እና ስትራቴጂካዊ ምክር።',
// Clients extras,
  ourPartners: 'ጋባሪ',
  ourPartnersHighlight: 'ማኅበረሰቦች',
  partnersDesc: 'ከኦል ቲንግስ ጋር ዲጂታል ታይነታቸውን የሚያስፋፉ የኢትዮጵያ ኢንोቬቲቭ ንግዶችን ይወቁ።',
  category: 'ምድብ',
  allCategoriesLabel: 'ሁሉም ምድቦች',
  city: 'ከተማ',
// Team extras,
  viewProfile: 'መገለጫ ይመልከቱ',
// Marketplace Homepage,
  mpHeroTitle: 'የተረጋጁጠና ድርጅቶች',
  mpHeroTitleHighlight: 'ገበያ',
  mpHeroDesc: 'የተታመኑ የኢትዮጵያ ድርጅቶችን ያግኙ፣ ጥሩ ጥራት ያላቸው ምርቶችን ይግዙ እና በአፍሪካ እያደገ የሚገኝ የዲጂታል ገበያዎ ላይ የእርስዎን ብርገት ያስፋፉ።',
  mpStartShopping: 'ግዢ ጀምር',
  mpRegisterBusiness: 'ድርጅትዎን ይመዝግቡ',
  mpStatBusinesses: 'የተረጋጁጠና ድርጅቶች',
  mpStatProducts: 'የተመዘገቡ ምርቶች',
  mpStatCities: 'የሚሸፈኑ ከተሞች',
  mpStatSatisfaction: 'የደአማሽነት እርግጠት',
  mpTrustVerified: 'የተረጋጁጠና ድርጅቶች',
  mpTrustSecure: 'ደህንነቱ የተጠበቀ ክፍያ',
  mpTrustReturns: 'ቀላል መመለስ',
  mpTrust247: '24/7 ድጋፍ',
  mpTrustVerifiedDesc: 'ሁሉም ድርጅቶች ፈቃድ ተስጠው ተረጋግጠዋል',
  mpTrustSecureDesc: 'በእያንዳንዱ ደረጃ ግብይቶች ይጠበቃሉ',
  mpTrustReturnsDesc: 'ምንማ የመመለስ ፖሊሲ',
  mpTrust247Desc: 'በማንኛውንደም እርዳታ እንሰጣለን',
  mpCatTitle: 'በ',
  mpCatTitleHighlight: 'ምድብ ይግዙ',
  mpCatDesc: 'በታዋቂ ምድቦች ውስጥ የሃዘሪያዎችን ምርቶች ያሳዩ',
  mpPaymentsTitle: 'ደህንነቱ የተጠበቀ',
  mpPaymentsTitleHighlight: 'የክፍያ ዘዴዎች',
  mpPaymentsDesc: 'ለልቃታዎ ብዙ ደህንነቱ የተጠበቀ የክፍያ አማራጮች',
  mpTestimonialTitle: 'የእኛ',
  mpTestimonialTitleHighlight: 'ሻሽላቶች የሚሉት',
  mpTestimonialDesc: 'በAll Things ላይ በተሻለ የሚሰሩ ድርጅቶች ያዳምጡ',
  mpNewsletterTitle: 'ወቅታዊ መረጃ ይጠቀሙ',
  mpNewsletterDesc: 'እድሎች፣ አዲስ ምርቶች እና የሽያጭ ቦታ ዜናዎች በይህ ኢሜይል ለመቀበል ይመዝግቡ።',
  mpNewsletterPlaceholder: 'ኢሜይል አድራሽዎን ያስገቡ',
  mpNewsletterBtn: 'ተመዝግቡ',
  mpNewsletterSuccess: '✅ ለመመዝገብዎ እናመሰግናለን!',
  mpFooterQuickLinks: 'ፈጣን አገናኞች',
};

